import React, { useState, useEffect } from 'react';
import { Button, Pagination, Modal, Select, Checkbox, DatePicker, Input, App } from 'antd';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAppSelector } from '@/store/hooks';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import { saveRideOrder, getCarpoolList, saveDeliveryOrder, getCarpoolDeliveryList } from '@/api/car';
import styles from './index.module.scss';
import SearchConponent from '@/components/SearchConponent/SearchConponent';
import icon1 from '@/assets/images/34f5bc776f1a4d71febca847a18af79@2x.png';
import icon2 from '@/assets/images/路径 2012@2x.png';
import { CheckCircleFilled, CrownFilled, CreditCardOutlined, CheckOutlined } from '@ant-design/icons';
import { useAppDispatch } from '@/store/hooks';
import { setUserInfo } from '@/store/slices/userSlice';
import { getCarpoolById, getDeliveryById } from '@/api/car';
import OrderDialogCar, { OrderDialogOrder, OrderDialogMode } from '@/components/OrderDialogCar/OrderDialogCar';

import Membership from '@/components/Membership';


interface OrderItem {
  delivery_order_id?: string;                      // 订单ID
  carpool_order_id?: string;                      // 订单ID
  departure_date: string;            // 出发时间
  acceptable_advance_delay: string;       // 可接受的提前量（分钟/小时，按业务定义）
  stopovers: string;               // 经停数量
  starting_point_state: string;               // 出发州
  starting_point_city: string;                // 出发城市
  starting_point_address: string;             // 出发详细地址
  destination_point_state: string;                 // 到达州
  destination_point_city: string;                  // 到达城市
  destination_point_address: string;               // 到达详细地址
  seats_needed: string;             // 需要座位数
  has_luggage: boolean;                // 是否有行李
  budget_price: string;                 // 出价
  service_requirements: string;     // 服务要求
  notes: string;
  distance: string;                   // 备注




  // Delivery specific fields
  pickup_time?: string;              // 取件时间
  expected_delivery_time?: string;   // 期望送达时间
  item_description?: string;         // 物品描述
  quantity?: string;                 // 数量
  package_size?: string;             // 包裹尺寸
  package_weight?: string;           // 包裹重量
}

const { TextArea } = Input;
const { Option } = Select;

const CarpoolService: React.FC = () => {

  const { t, i18n } = useTranslation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const userInfo = useAppSelector((state) => state.user.userInfo);
  const [detail, setDetail] = useState<any>();
  const [dialogMode, setDialogMode] = useState<OrderDialogMode>('bidding');
  const [dialogOpen, setDialogOpen] = useState(false);
  const dispatch = useAppDispatch();
  //美国州列表
  const StateList = useAppSelector((state) => state.common.StateList);

  // 是否是手机端
  const isMobile = useAppSelector((state) => state.searchBar.isMobile);

  //获取经纬度
  const latitude = useAppSelector((state) => state.user.latitude);
  const longitude = useAppSelector((state) => state.user.longitude);

  const { message } = App.useApp();



  //拼车送人记录列表
  const [carList, setCarList] = useState<OrderItem[]>([

  ]);

  //拼车送货记录列表
  const [deliveryList, setDeliveryList] = useState<OrderItem[]>([


  ]);


  // 区分是送人订单还是送货订单
  const [activeTab, setActiveTab] = useState<string>('ride');

  //入参
  const [params, setParams] = useState<any>({
    page_num: 1,
    page_size: 20,
    total: 0,
    totalPages: 0,
    keyword: '',
    user_latitude: 0,
    user_longitude: 0,
  });

  // 分页信息
  const [goToPage, setGoToPage] = useState<string>('');


  //切换拼车还是送货列表
  const setActiveTabFn = (tab: string) => {

    setActiveTab(tab);
    //获取拼车列表
    const myParams = {
      ...params,
      page_num: 1,
      page_size: 20,
      total: 0,
      totalPages: 0,
      keyword: '',
    };
    setParams(myParams);

    if (tab === 'ride') {
      getProductListFn();
    } else {
      getDeliveryListFn();
    }

    navigate(`/carpoolService?type=${tab}`);

  }

  //获取商品列表方法
  const getProductListFn = () => {
    const myParams = {
      ...params,
      user_latitude: latitude,//latitude   41.71882
      user_longitude: longitude,//-72.99009
    };
    getCarpoolList(myParams).then((res) => {
      if (res.code == 200) {
        setCarList(res.data);
        setParams((prevParams: any) => ({
          ...prevParams,
          page_num: params.page_num,
          total: res.total || 0,
          totalPages: res.totalPages || 1,
        }));
        setGoToPage('');
      }
    })
  }

  //获取送货列表方法
  const getDeliveryListFn = () => {
    const myParams = {
      ...params,
      user_latitude: latitude,//latitude   41.71882
      user_longitude: longitude,//-72.99009
    };
    getCarpoolDeliveryList(myParams).then((res) => {
      if (res.code == 200) {
        const data = res.data;
        setDeliveryList(data.data);
        setParams((prevParams: any) => ({
          ...prevParams,
          page_num: params.page_num,
          total: data.total || 0,
          totalPages: data.totalPages || 1,
        }));
        setGoToPage('');
      }
    })
  }


  // 处理页码输入框回车事件
  const handlePageInputKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleGoToPage();
    }
  };

  // 分页变化
  const paginationChange = (page: number, pageSize: number) => {
    console.log('page', page, pageSize);

    const myParams = {
      ...params,
      page_num: page,
      page_size: pageSize,
    };
    setParams(myParams);
    if (activeTab === 'ride') {
      getProductListFn();
    } else {
      getDeliveryListFn();
    }

  };

  // 跳转到指定页
  const handleGoToPage = () => {

    const page = parseInt(goToPage);

    if (isNaN(page) || page < 1) {
      return;
    }


    if (page > params.totalPages) {
      return;
    }

    const myParams = {
      ...params,
      page_num: page,
    };

    setParams(myParams);

    if (activeTab === 'ride') {
      getProductListFn();
    } else {
      getDeliveryListFn();
    }


  };


  const getMessage = (message: string) => {
    console.log(message); // 处理搜索框输入的消息
    const myParams = {
      ...params,
      keyword: message,
      page_num: 1,
    };
    setParams(myParams);
    if (activeTab === 'ride') {
      getProductListFn();
    } else {
      getDeliveryListFn();
    }
  }

  //是否是会员
  const [isMember, setIsMember] = useState(false);

  // 添加会员弹窗状态控制
  const [membershipModalOpen, setMembershipModalOpen] = useState<boolean>(false);


  // 支付成功弹窗
  const [showPaySuccess, setShowPaySuccess] = useState(false);
  const closePaySuccess = () => setShowPaySuccess(false);

  // 发布顺风车帖子弹窗
  const [showPublishModal, setShowPublishModal] = useState(false);
  // 发布送货帖子弹窗
  const [showPublishDeliveryModal, setShowPublishDeliveryModal] = useState(false);


  // 发布顺风车帖子表单
  const [publishForm, setPublishForm] = useState<any>({
    carpool_order_id: undefined,
    departure_date: '',
    acceptable_advance_delay: '',
    stopovers: '',
    starting_point_state: '',
    starting_point_city: '',
    starting_point_address: '',
    destination_point_state: '',
    destination_point_city: '',
    destination_point_address: '',
    seats_needed: '',
    has_luggage: true,
    budget_price: '',
    service_requirements: '',
    notes: ''
  });

  // 发布送货帖子表单
  const [publishDeliveryForm, setPublishDeliveryForm] = useState<any>({
    delivery_order_id: undefined,
    pickup_time: '',
    expected_delivery_time: '',
    starting_point_state: '',
    starting_point_city: '',
    starting_point_address: '',
    destination_point_state: '',
    destination_point_city: '',
    destination_point_address: '',
    item_description: '',
    quantity: '',
    package_size: '',
    package_weight: '',
    budget_price: '',
    notes: ''
  });

  // 修改表单内容
  const handlePublishChange = (key: string, value: any) => {
    setPublishForm((prev: any) => ({ ...prev, [key]: value }));
  };

  // 修改送货表单内容
  const handlePublishDeliveryChange = (key: string, value: any) => {
    setPublishDeliveryForm((prev: any) => ({ ...prev, [key]: value }));
  };

  //乘客发布行程单让司机去接
  const handlePublish = () => {
    //如果乘客还没有注册会员
    if (!isMember) {
      setMembershipModalOpen(true);
      return;
    } else {
      //如果乘客已经是会员，根据当前tab决定打开哪个弹窗
      if (activeTab === 'ride') {
        setShowPublishModal(true);
      } else {
        setShowPublishDeliveryModal(true);
      }
    }
  };



  // 点击发布顺风车送人帖子
  const submitPostRide = async () => {
    // 这里可接入后端发布接口
    if (!publishForm.departure_date) {
      message.error('Departure Date is required');
      return;
    }
    const departureDate = dayjs(publishForm.departure_date);
    if (!departureDate.isValid() || departureDate.isBefore(dayjs())) {
      message.error('Departure Date must be in the future');
      return;
    }

    if (!publishForm.acceptable_advance_delay) {
      message.error('Acceptable advance/delay is required');
      return;
    }

    if (!publishForm.stopovers) {
      message.error('Stopovers is required');
      return;
    }

    if (!publishForm.starting_point_state) {
      message.error('From State is required');
      return;
    }

    if (!publishForm.starting_point_city) {
      message.error('From City is required');
      return;
    }

    if (!publishForm.starting_point_address) {
      message.error('From Address is required');
      return;
    }

    if (!publishForm.destination_point_state) {
      message.error('To State is required');
      return;
    }

    if (!publishForm.destination_point_city) {
      message.error('To City is required');
      return;
    }

    if (!publishForm.destination_point_address) {
      message.error('To Address is required');
      return;
    }

    if (!publishForm.seats_needed) {
      message.error('Seats Needed is required');
      return;
    }


    if (!publishForm.has_luggage && publishForm.has_luggage !== false) {
      message.error('Luggage is required');
      return;
    }

    // if (!publishForm.fixed_price) {
    //   message.error('Fixed Price is required');
    //   return;
    // }
    // if (!publishForm.bidding_price) {
    //   message.error('Bidding is required');
    //   return;
    // }

    // 一口价不能大于竞拍最高价格
    if (Number(publishForm.fixed_price) > Number(publishForm.bidding_price)) {
      message.error('The fixed price cannot exceed the highest bidding price');
      return;
    }

    const publishFormCopy = {
      ...publishForm,
      departure_date: dayjs(publishForm.departure_date).format('YYYY-MM-DD HH:mm:ss'),  //YYYY-MM-DD HH:mm:ss    MM-DD-YYYY HH:mm:ss
    };

    // 获取经纬度
    const key = process.env.REACT_APP_GOOGLE_MAP_KEY as string;

    // 起点
    const startingAddr = publishFormCopy.starting_point_address + ',' + publishFormCopy.starting_point_city + ',' + publishFormCopy.starting_point_state;

    // 终点
    const endAddr = publishFormCopy.destination_point_address + ',' + publishFormCopy.destination_point_city + ',' + publishFormCopy.destination_point_state;

    let startingLatitude: number | null = null;
    let startingLongitude: number | null = null;

    let endLatitude: number | null = null;
    let endLongitude: number | null = null;

    try {
      //debugger
      if (!startingAddr || !key) {
        console.log('地址或地图密钥缺失');
        return;
      }
      const geoRes = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(startingAddr)}&key=${key}`);
      const geoJson = await geoRes.json();
      if (geoJson.status === 'OK' && geoJson.results && geoJson.results[0]) {
        const loc = geoJson.results[0].geometry.location;
        startingLatitude = loc.lat;
        startingLongitude = loc.lng;
      } else {
        console.log('地址解析失败，请检查地址');
        return;
      }
    } catch (e) {
      console.error('地址解析异常:', e);
      return;
    }

    try {
      //debugger
      if (!endAddr || !key) {
        console.log('地址或地图密钥缺失');
        return;
      }
      const geoRes = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(endAddr)}&key=${key}`);
      const geoJson = await geoRes.json();
      if (geoJson.status === 'OK' && geoJson.results && geoJson.results[0]) {
        const loc = geoJson.results[0].geometry.location;
        endLatitude = loc.lat;
        endLongitude = loc.lng;
      } else {
        console.log('地址解析失败，请检查地址');
        return;
      }
    } catch (e) {
      console.error('地址解析异常:', e);
      return;
    }

    // 调用发布接口
    //publishFormCopy.starting_point_latitude = 32.14316736398072 //Number(startingLatitude?.toFixed(5));
    //publishFormCopy.starting_point_longitude = 118.7122410755883 //Number(startingLongitude?.toFixed(5));

    publishFormCopy.starting_point_latitude = Number(startingLatitude?.toFixed(5));
    publishFormCopy.starting_point_longitude = Number(startingLongitude?.toFixed(5));

    publishFormCopy.destination_point_latitude = Number(endLatitude?.toFixed(5));
    publishFormCopy.destination_point_longitude = Number(endLongitude?.toFixed(5));

    saveRideOrder(publishFormCopy).then((res: any) => {
      if (res.code === 200) {
        message.success('Post ride successfully');
        setShowPublishModal(false);

        const myParams = {
          ...params,
          page_num: 1
        };
        setParams(myParams);
        //获取拼车列表
        getProductListFn();

        setPublishForm({
          carpool_order_id: undefined,
          departure_date: '',
          acceptable_advance_delay: '',
          stopovers: '',
          starting_point_state: '',
          starting_point_city: '',
          starting_point_address: '',
          destination_point_state: '',
          destination_point_city: '',
          destination_point_address: '',
          seats_needed: '',
          has_luggage: true,
          fixed_price: '',
          bidding_price: '',
          service_requirements: '',
          notes: ''
        });

      } else {
        message.error('Post ride failed');
      }
    });

  };

  //取消发布
  const cancelSubmit = () => {
    console.log('save draft:', publishForm);
    setShowPublishModal(false);
  };

  // 点击发布送货帖子
  const submitPostDelivery = async () => {
    // 验证表单
    if (!publishDeliveryForm.pickup_time) {
      message.error('Pickup Time is required');
      return;
    }
    const pickupTime = dayjs(publishDeliveryForm.pickup_time);
    if (!pickupTime.isValid() || pickupTime.isBefore(dayjs())) {
      message.error('Pickup Time must be in the future');
      return;
    }

    if (!publishDeliveryForm.expected_delivery_time) {
      message.error('Expected Delivery Time is required');
      return;
    }
    const expectedDeliveryTime = dayjs(publishDeliveryForm.expected_delivery_time);
    if (!expectedDeliveryTime.isValid() || expectedDeliveryTime.isBefore(dayjs())) {
      message.error('Expected Delivery Time must be in the future');
      return;
    }

    if (!publishDeliveryForm.starting_point_state) {
      message.error('Pickup State is required');
      return;
    }

    if (!publishDeliveryForm.starting_point_city) {
      message.error('Pickup City is required');
      return;
    }

    if (!publishDeliveryForm.starting_point_address) {
      message.error('Pickup Address is required');
      return;
    }

    if (!publishDeliveryForm.destination_point_state) {
      message.error('Drop-Off State is required');
      return;
    }

    if (!publishDeliveryForm.destination_point_city) {
      message.error('Drop-Off City is required');
      return;
    }

    if (!publishDeliveryForm.destination_point_address) {
      message.error('Drop-Off Address is required');
      return;
    }

    if (!publishDeliveryForm.item_description) {
      message.error('Item Description is required');
      return;
    }

    if (!publishDeliveryForm.quantity) {
      message.error('Quantity is required');
      return;
    }

    if (!publishDeliveryForm.package_size) {
      message.error('Package Size is required');
      return;
    }

    if (!publishDeliveryForm.package_weight) {
      message.error('Package Weight is required');
      return;
    }

    if (!publishDeliveryForm.fixed_price) {
      message.error('Fixed Price is required');
      return;
    }

    if (!publishDeliveryForm.bidding_price) {
      message.error('Bidding is required');
      return;
    }

    // 一口价不能大于竞拍最高价格
    if (Number(publishDeliveryForm.fixed_price) > Number(publishDeliveryForm.bidding_price)) {
      message.error('The fixed price cannot exceed the highest bidding price');
      return;
    }

    const publishDeliveryFormCopy = {
      ...publishDeliveryForm,
      pickup_time: dayjs(publishDeliveryForm.pickup_time).format('YYYY-MM-DD HH:mm:ss'),
      expected_delivery_time: dayjs(publishDeliveryForm.expected_delivery_time).format('YYYY-MM-DD HH:mm:ss'),
    };

    console.log('post delivery form:', publishDeliveryFormCopy);

    // 获取经纬度
    const key = process.env.REACT_APP_GOOGLE_MAP_KEY as string;

    // 起点
    const startingAddr = publishDeliveryFormCopy.starting_point_address + ',' + publishDeliveryFormCopy.starting_point_city + ',' + publishDeliveryFormCopy.starting_point_state;

    // 终点
    const endAddr = publishDeliveryFormCopy.destination_point_address + ',' + publishDeliveryFormCopy.destination_point_city + ',' + publishDeliveryFormCopy.destination_point_state;

    let startingLatitude: number | null = null;
    let startingLongitude: number | null = null;

    let endLatitude: number | null = null;
    let endLongitude: number | null = null;

    try {
      if (!startingAddr || !key) {
        console.log('地址或地图密钥缺失');
        return;
      }
      const geoRes = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(startingAddr)}&key=${key}`);
      const geoJson = await geoRes.json();
      if (geoJson.status === 'OK' && geoJson.results && geoJson.results[0]) {
        const loc = geoJson.results[0].geometry.location;
        startingLatitude = loc.lat;
        startingLongitude = loc.lng;
      } else {
        console.log('地址解析失败，请检查地址');
        return;
      }
    } catch (e) {
      console.error('地址解析异常:', e);
      return;
    }

    try {
      if (!endAddr || !key) {
        console.log('地址或地图密钥缺失');
        return;
      }
      const geoRes = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(endAddr)}&key=${key}`);
      const geoJson = await geoRes.json();
      if (geoJson.status === 'OK' && geoJson.results && geoJson.results[0]) {
        const loc = geoJson.results[0].geometry.location;
        endLatitude = loc.lat;
        endLongitude = loc.lng;
      } else {
        console.log('地址解析失败，请检查地址');
        return;
      }
    } catch (e) {
      console.error('地址解析异常:', e);
      return;
    }

    // 调用发布接口
    // publishDeliveryFormCopy.starting_point_latitude = Number(startingLatitude?.toFixed(5));
    // publishDeliveryFormCopy.starting_point_longitude = Number(startingLongitude?.toFixed(5));

    publishDeliveryFormCopy.starting_point_latitude = 32.14316736398072 //Number(startingLatitude?.toFixed(5));
    publishDeliveryFormCopy.starting_point_longitude = 118.7122410755883 //Number(startingLongitude?.toFixed(5));

    publishDeliveryFormCopy.destination_point_latitude = Number(endLatitude?.toFixed(5));
    publishDeliveryFormCopy.destination_point_longitude = Number(endLongitude?.toFixed(5));

    // TODO: 调用送货订单接口 saveDeliveryOrder
    saveDeliveryOrder(publishDeliveryFormCopy).then((res: any) => {
      if (res.code === 200) {
        message.success('Post delivery successfully');
        setShowPublishDeliveryModal(false);

        const myParams = {
          ...params,
          page_num: 1
        };
        setParams(myParams);
        //获取拼车送货列表
        getDeliveryListFn();
        setPublishDeliveryForm({
          carpool_order_id: undefined,
          pickup_time: '',
          expected_delivery_time: '',
          starting_point_state: '',
          starting_point_city: '',
          starting_point_address: '',
          destination_point_state: '',
          destination_point_city: '',
          destination_point_address: '',
          item_description: '',
          quantity: '',
          package_size: '',
          package_weight: '',
          fixed_price: '',
          bidding_price: '',
          notes: ''
        });

      } else {
        message.error('Post delivery failed');
      }
    });
  };

  //取消发布送货
  const cancelDeliverySubmit = () => {
    console.log('save draft:', publishDeliveryForm);
    setShowPublishDeliveryModal(false);
  };


  // 处理会员购买弹窗的回调函数
  const handleMembershipCancel = () => {
    setMembershipModalOpen(false);
  };

  //支付会员确认
  const handleMembershipConfirm = (values: any) => {
    console.log('Membership purchase confirmed:', values);

    // 检查是否是支付成功
    if (values.paymentSuccess) {
      message.success('Membership purchased successfully! You can now submit emergency service requests.');
      setMembershipModalOpen(false);
      setIsMember(true);
      setShowPaySuccess(true);



      // // 支付成功后，更新 localStorage 中的 userinfo
      const userInfoStr = localStorage.getItem('userInfo');
      let userInfo = userInfoStr ? JSON.parse(userInfoStr) : {};
      //把购买的会员标识手动处理
      userInfo.carpool_service_member = true;

      dispatch(setUserInfo(userInfo));


    } else {
      setMembershipModalOpen(false);
      // // 如果没有支付成功信息，按原来的逻辑处理

    }
  };

  //
  const goToOrders = () => {
    setShowPaySuccess(false);
    navigate('/yourtownloop/orders');
  };

  const goToHome = () => {
    setShowPaySuccess(false);
    navigate('/');
  };
  const openDialog = (mode: OrderDialogMode) => {
      setDialogMode(mode);
      setDialogOpen(true);
    };
  // 点击竞价根据id获取当前订单详情(不过接口获取的详情和列表的详情可能有差异)
  const onBiddingClick = (event: React.MouseEvent<HTMLElement>, item: any) => {
    event.stopPropagation()
    getCarpoolById({carpool_order_id: item.carpool_order_id}).then((res: any) => {
      if (res.code === 200) {
        setDetail(res.data);
        // 获取到详情后打开bidding弹框
        openDialog('bidding');
      }
    })
  }
  useEffect(() => {
    // 判断是否是会员
    if (!!userInfo?.carpool_service_member) {
      setIsMember(true);
    }
  }, [userInfo]);

  useEffect(() => {
    const type = searchParams.get('type') || 'ride';
    setActiveTabFn(type)
  }, [])

  // useEffect(() => {

  //   const type = searchParams.get('type') || 'ride';
  //   console.log('typetypetypetype', type);
  //   if (type === 'ride') {
  //     setActiveTabFn('ride');
  //   } else {
  //     setActiveTabFn('delivery');
  //   }

  // }, [searchParams]);

  return (
    <div className={styles['carpool-page']}>
      <div className={styles['search-wrap']}>
        <SearchConponent getMessage={getMessage} />
      </div>

      <div className={styles['banner-wrap']}>
        <img src={icon1} alt="banner" className={styles['banner-img']} />
      </div>

      <div className={styles['section-header']}>
        <div className='flex items-center'>
          <div className='flex items-center gap-8'>
            <h2 className={`${styles['section-title']} ${activeTab === 'ride' ? styles['active'] : ''}`}
              onClick={() => setActiveTabFn('ride')}>{t('CarpoolService.RideBoard')}</h2>
            <h2 className={`${styles['section-title']} ${activeTab === 'delivery' ? styles['active'] : ''}`}
              onClick={() => setActiveTabFn('delivery')}>{t('CarpoolService.Delivery')}</h2>
          </div>
          <div className='ml-8 text-[14px] text-[#7F9298] font-normal'>
            {t('CarpoolService.Distance10')}
          </div>
        </div>

        <Button
          className={styles['publish-btn']}
          onClick={handlePublish}
        >{t('CarpoolService.PublishImmediately')}</Button>
      </div>
      {/* 拼车送人列表 */}
      {activeTab === 'ride' && (
        <div className={styles['cards-grid']}>
          {carList.map((item, idx) => (
            <div className={styles['order-card']} key={idx} onClick={() => navigate(`/CarpoolServiceDetail/${item.carpool_order_id}`)}>
              <div className={styles['card-top']}>
                <div className={styles['status-badge']}>
                  <span className={styles['percent']}>95% </span>
                  <span className={styles['status']}> {t('CarpoolService.OnTheWay')}</span>
                </div>
                <div className={styles['datetime']}>
                  <span className={styles['percent']}>{t('CarpoolService.DepartureDate')}: </span>
                  <span className={styles['date']}>{item.departure_date}</span>
                  {/* <span className={styles['time']}>{item.timeRange}</span> */}
                </div>
              </div>

              <div className={styles['addr-box']}>
                <ul className={styles['addr-list']}>
                  <li
                    className={styles['addr-item']}
                    title={item.starting_point_address + ', ' + item.starting_point_city + ',' + item.starting_point_state}
                  >{item.starting_point_address + ', ' + item.starting_point_city + ',' + item.starting_point_state}</li>
                  <li
                    className={styles['addr-item']}
                    title={item.destination_point_address + ', ' + item.destination_point_city + ',' + item.destination_point_state}
                  >{item.destination_point_address + ', ' + item.destination_point_city + ',' + item.destination_point_state}</li>
                  <li className={`${styles['addr-item']} ${styles['distance']}`}>
                    <img src={icon2} alt="" className={styles['pin']} />
                    {item.distance} {t('CarpoolService.MilesFromYou')}
                  </li>
                </ul>

                <div className={styles['price-box']}>
                  <div className={styles['price']}>${ item.budget_price }</div>
                  <div className={styles['estimate']}>{t('CarpoolService.Estimate')}</div>
                </div>
              </div>


              <div className={styles['card-bottom']}>
                <div>
                  <div className={styles['meta']}>
                    <span className={styles['meta-label']}>{t('CarpoolService.SeatsNeeded')}:</span>
                    <span className={styles['meta-value']}>{item.seats_needed} {t('CarpoolService.People')}</span>
                  </div>
                  <div className={styles['meta']}>
                    <span className={styles['meta-label']}>{t('CarpoolService.Luggage')}:</span>
                    <span className={styles['meta-value']}>{item.has_luggage ? t('CarpoolService.HasLuggage') : t('CarpoolService.NoLuggage')}</span>
                  </div>
                </div>

                <Button className={styles['details-btn']} onClick={(event) => onBiddingClick(event, item)}>{t('CarpoolService.Bidding')}</Button>
              </div>
            </div>
          ))}
        </div>
      )}

      {activeTab === 'ride' && carList.length > 0 &&
        <div className={styles['pagination-container']}>
          <div className={styles['pagination-info']}>Total {params.total} Products</div>
          <Pagination
            onChange={paginationChange}
            current={params.page_num}
            pageSize={params.page_size}
            total={params.total}
            showSizeChanger={false}
            responsive
            hideOnSinglePage={params.totalPages <= 1}
          />
          <div className={styles['go-to-page']}>
            go to
            <input
              className={styles['page-input']}
              type="text"
              value={goToPage}
              onChange={(e) => setGoToPage(e.target.value)}
              onKeyDown={handlePageInputKeyDown}
            />
            page
            <Button
              size="small"
              style={{ marginLeft: 8 }}
              onClick={handleGoToPage}
            >
              GO
            </Button>
          </div>
        </div>
      }

      {/* 拼车送人列表 */}

      {/* 拼车送货列表 */}
      {activeTab === 'delivery' && (
        <div className={styles['cards-grid']}>
          {deliveryList.map((item, idx) => (
            <div className={styles['order-card']} key={idx}>
              <div className={styles['card-top']}>
                <div className={styles['status-badge']}>
                  <span className={styles['percent']}>95%</span>
                  <span className={styles['status']}>On The Way</span>
                </div>
                <div className={styles['datetime']}>
                  <span className={styles['date']}>{item.pickup_time}</span>
                  {/* <span className={styles['time']}>{item.expected_delivery_time}</span> */}
                </div>

              </div>

              <div className={styles['addr-box']}>
                <ul className={styles['addr-list']}>
                  <li
                    className={styles['addr-item']}
                    title={item.starting_point_address + ', ' + item.starting_point_city + ', ' + item.starting_point_state}
                  >{item.starting_point_address + ', ' + item.starting_point_city + ', ' + item.starting_point_state}</li>
                  <li
                    className={styles['addr-item']}
                    title={item.destination_point_address + ', ' + item.destination_point_city + ', ' + item.destination_point_state}
                  >{item.destination_point_address + ', ' + item.destination_point_city + ', ' + item.destination_point_state}</li>
                  <li className={`${styles['addr-item']} ${styles['distance']}`}>
                    <img src={icon2} alt="" className={styles['pin']} />
                    {item.distance} Miles From You
                  </li>
                </ul>

                {/* <div className={styles['price-box']}>
                  <div className={styles['price']}>${item.fixed_price}</div>
                  <div className={styles['estimate']}>Estimate</div>
                </div> */}
              </div>


              <div className={styles['card-bottom']}>
                <div>
                  <div className={styles['meta']}>
                    <span className={styles['meta-label']}>Item Description:</span>
                    <span className={styles['meta-value']}>{item.item_description}</span>
                  </div>
                  <div className={styles['meta']}>
                    <span className={styles['meta-label']}>Package Size:</span>
                    <span className={styles['meta-value']}>{item.package_size}</span>
                  </div>
                  <div className={styles['meta']}>
                    <span className={styles['meta-label']}>Package Weight:</span>
                    <span className={styles['meta-value']}>{item.package_weight}</span>
                  </div>
                </div>

                <Button className={styles['details-btn']} onClick={() => navigate(`/CarpoolServiceDetail/${item.delivery_order_id}?type=delivery`)}>Details</Button>
              </div>

            </div>
          ))}
        </div>
      )}

      {activeTab === 'delivery' && deliveryList.length > 0 &&
        <div className={styles['pagination-container']}>
          <div className={styles['pagination-info']}>Total {params.total} Products</div>
          <Pagination
            onChange={paginationChange}
            current={params.page_num}
            pageSize={params.page_size}
            total={params.total}
            showSizeChanger={false}
            responsive
            hideOnSinglePage={params.totalPages <= 1}
          />
          <div className={styles['go-to-page']}>
            go to
            <input
              className={styles['page-input']}
              type="text"
              value={goToPage}
              onChange={(e) => setGoToPage(e.target.value)}
              onKeyDown={handlePageInputKeyDown}
            />
            page
            <Button
              size="small"
              style={{ marginLeft: 8 }}
              onClick={handleGoToPage}
            >
              GO
            </Button>
          </div>
        </div>
      }

      {/* 拼车送货列表 */}




      {/* 会员支付弹窗 */}

      <Membership
        open={membershipModalOpen}
        onCancel={handleMembershipCancel}
        onConfirm={handleMembershipConfirm}
        membershipType={1}
      />
      {/* 会员支付弹窗 */}

      {/* 发布顺风车送人表单弹窗 */}
      <Modal
        open={showPublishModal}
        onCancel={() => setShowPublishModal(false)}
        footer={null}
        width={1200}
        centered
        maskClosable={false}
        className={styles['publish-modal']}

      >
        <div className={styles['publish-title']}>{t('CarpoolService.PostRide')}</div>
        <div className={styles['publish-body']}>
          <div className={styles['form-columns']}>
            {/* 左列 */}
            <div className={styles['left-column']}>
              <div className={styles['form-group']}>
                <label className={styles['form-label']}>*{t('CarpoolService.DepartureDate')}:</label>
                {/* format('YYYY-MM-DD HH:mm:ss'),  //YYYY-MM-DD HH:mm:ss    MM-DD-YYYY HH:mm:ss */}
                <DatePicker
                  showTime
                  format="MM-DD-YYYY HH:mm:ss"
                  className={styles['input']}
                  value={publishForm.departure_date}
                  placeholder={t('CarpoolService.DepartureDate')}
                  onChange={(v) => handlePublishChange('departure_date', v)}
                />
              </div>

              <div className={styles['form-group']}>
                <label className={styles['form-label']}>*{t('CarpoolService.AcceptableAdvanceDelay')}:</label>
                <Input
                  type="number"
                  className={styles['input']}
                  placeholder={t('CarpoolService.AcceptableAdvanceDelay')}
                  value={publishForm.acceptable_advance_delay}
                  onChange={(e) => handlePublishChange('acceptable_advance_delay', e.target.value)}
                />
              </div>

              <div className={styles['form-group']}>
                <label className={styles['form-label']}>*{t('CarpoolService.StartingPoint')}:</label>
                <div className={styles['nested-inputs']}>
                  <Select
                    className={styles['input']}
                    placeholder={t('CarpoolService.StartingPoint')}
                    value={publishForm.starting_point_state}
                    onChange={(v) => handlePublishChange('starting_point_state', v)}
                  >
                    {
                      StateList.map((item, index) => (
                        <Option value={item.value} key={index}>{item.label}</Option>
                      ))
                    }

                  </Select>
                  <Input
                    className={styles['input']}
                    placeholder={t('CarpoolService.City')}
                    value={publishForm.starting_point_city}
                    onChange={(e) => handlePublishChange('starting_point_city', e.target.value)}
                  />
                  <Input
                    className={styles['input']}
                    placeholder={t('CarpoolService.Address')}
                    value={publishForm.starting_point_address}
                    onChange={(e) => handlePublishChange('starting_point_address', e.target.value)}
                  />
                </div>
              </div>

              <div className={styles['form-group']}>
                <label className={styles['form-label']}>*{t('CarpoolService.SeatsNeeded')}:</label>
                <Select
                  className={styles['input']}
                  placeholder={t('CarpoolService.SeatsNeeded')}
                  value={publishForm.seats_needed}
                  onChange={(v) => handlePublishChange('seats_needed', v)}
                >
                  <Option value="1">1</Option>
                  <Option value="2">2</Option>
                  <Option value="3">3</Option>
                  <Option value="4">4</Option>

                </Select>
              </div>

              {/* <div className={styles['form-group']}>
                <label className={styles['form-label']}>*{t('CarpoolService.FixedPrice')}:</label>
                <Input
                  type='number'
                  className={styles['input']}
                  placeholder={t('CarpoolService.FixedPrice')}
                  value={publishForm.fixed_price}
                  onChange={(e) => handlePublishChange('fixed_price', e.target.value)}
                />
              </div> */}
              <div className={styles['form-group']}>
                <label className={styles['form-label']}>*{t('CarpoolService.Budget')}:</label>
                <Input
                  type='number'
                  className={styles['input']}
                  placeholder={t('CarpoolService.Budget')}
                  value={publishForm.bidding_price}
                  onChange={(e) => handlePublishChange('budget_price',e.target.value)}
                />
              </div>
              <div className={styles['form-group']}>
                <label className={styles['form-label']}>{t('CarpoolService.Notes')}:</label>
                <Input
                  className={styles['input']}
                  placeholder={t('CarpoolService.Notes')}
                  value={publishForm.notes}
                  onChange={(e) => handlePublishChange('notes', e.target.value)}
                />
              </div>
            </div>

            {/* 右列 */}
            <div className={styles['right-column']}>
              <div className={styles['form-group']} style={{ marginTop: '82px' }}>
                <label className={styles['form-label']}>*{t('CarpoolService.Stopovers')}:</label>
                <Select
                  className={styles['input']}
                  placeholder={t('CarpoolService.Stopovers')}
                  value={publishForm.stopovers}
                  onChange={(v) => handlePublishChange('stopovers', v)}
                >
                  <Option value="0">0</Option>
                  <Option value="1">1</Option>
                  <Option value="2">2</Option>
                </Select>
              </div>

              <div className={styles['form-group']}>
                <label className={styles['form-label']}>*{t('CarpoolService.Destination')}:</label>
                <div className={styles['nested-inputs']}>
                  <Select
                    className={styles['input']}
                    placeholder="State"
                    value={publishForm.destination_point_state}
                    onChange={(v) => handlePublishChange('destination_point_state', v)}
                  >
                    {
                      StateList.map((item, index) => (
                        <Option value={item.value} key={index}>{item.label}</Option>
                      ))
                    }
                  </Select>
                  <Input
                    className={styles['input']}
                    placeholder={t('CarpoolService.City')}
                    value={publishForm.destination_point_city}
                    onChange={(e) => handlePublishChange('destination_point_city', e.target.value)}
                  />
                  <Input
                    className={styles['input']}
                    placeholder={t('CarpoolService.Address')}
                    value={publishForm.destination_point_address}
                    onChange={(e) => handlePublishChange('destination_point_address', e.target.value)}
                  />
                </div>
              </div>

              <div className={styles['form-group']}>
                <label className={styles['form-label']}>*{t('CarpoolService.Luggage')}:</label>
                <Select
                  className={styles['input']}
                  placeholder={t('CarpoolService.Luggage')}
                  value={publishForm.has_luggage}
                  onChange={(v) => handlePublishChange('has_luggage', v)}
                >
                  <Option value="" selected>{t('CarpoolService.Select')}</Option>
                  <Option value={true}>{t('CarpoolService.HasLuggage')}</Option>
                  <Option value={false}>{t('CarpoolService.NoLuggage')}</Option>

                </Select>
              </div>

              

              
              <div className={styles['form-group']}>
                <label className={styles['form-label']}>{t('CarpoolService.ServiceRequirements')}:</label>
                <Input
                  className={styles['input']}
                  placeholder={t('CarpoolService.ServiceRequirements')}
                  value={publishForm.service_requirements}
                  onChange={(e) => handlePublishChange('service_requirements', e.target.value)}
                />
              </div>
            </div>
          </div>

          <div className={styles['publish-actions']}>

            <Button className={styles['cancel-btn']} onClick={cancelSubmit}>{t('common.Cancel')}</Button>
            <Button className={styles['post-ride-btn']} type="primary" onClick={submitPostRide}>{t('CarpoolService.PostRide')}</Button>
          </div>
        </div>
      </Modal>
      {/* 发布顺风车送人表单弹窗 */}

      {/* 发布送货表单弹窗 */}
      <Modal
        open={showPublishDeliveryModal}
        onCancel={() => setShowPublishDeliveryModal(false)}
        footer={null}
        width={1200}
        centered
        maskClosable={false}
        className={styles['publish-modal']}
      >
        <div className={styles['publish-title']}>Post Delivery</div>
        <div className={styles['publish-body']}>
          <div className={styles['form-columns']}>
            {/* 左列 */} 
            <div className={styles['left-column']}>
              <div className={styles['form-group']}>
                <label className={styles['form-label']}>*Pickup Location:</label>
                <div className={styles['nested-inputs']}>
                  <Select
                    className={styles['input']}
                    placeholder="State"
                    value={publishDeliveryForm.starting_point_state}
                    onChange={(v) => handlePublishDeliveryChange('starting_point_state', v)}
                  >
                    {
                      StateList.map((item, index) => (
                        <Option value={item.value} key={index}>{item.label}</Option>
                      ))
                    }
                  </Select>
                  <Input
                    className={styles['input']}
                    placeholder="City"
                    value={publishDeliveryForm.starting_point_city}
                    onChange={(e) => handlePublishDeliveryChange('starting_point_city', e.target.value)}
                  />
                  <Input
                    className={styles['input']}
                    placeholder="Address"
                    value={publishDeliveryForm.starting_point_address}
                    onChange={(e) => handlePublishDeliveryChange('starting_point_address', e.target.value)}
                  />
                </div>
              </div>

              <div className={styles['form-group']}>
                <label className={styles['form-label']}>*Pickup Time:</label>
                <DatePicker
                  showTime
                  format="YYYY-MM-DD HH:mm A"
                  className={styles['input']}
                  value={publishDeliveryForm.pickup_time}
                  placeholder="2025-10-16 10:00 AM"
                  onChange={(v) => handlePublishDeliveryChange('pickup_time', v)}
                />
              </div>

              <div className={styles['form-group']}>
                <label className={styles['form-label']}>*Item Description:</label>
                <Input
                  className={styles['input']}
                  placeholder="E.G. Cake"
                  value={publishDeliveryForm.item_description}
                  onChange={(e) => handlePublishDeliveryChange('item_description', e.target.value)}
                />
              </div>

              <div className={styles['form-group']}>
                <label className={styles['form-label']}>*Package Size:</label>
                <Select
                  className={styles['input']}
                  placeholder="Small (≤ 12 × 8 × 4 In)"
                  value={publishDeliveryForm.package_size}
                  onChange={(v) => handlePublishDeliveryChange('package_size', v)}
                >
                  <Option value="Small (≤ 12 × 8 × 4 In)">Small (≤ 12 × 8 × 4 In)</Option>
                  <Option value="Medium (≤ 20 × 16 × 12 In)">Medium (≤ 20 × 16 × 12 In)</Option>
                  <Option value="Large (≤ 32 × 24 × 20 In)">Large (≤ 32 × 24 × 20 In)</Option>
                  <Option value="Extra Large (> 32 × 24 × 20 In)">Extra Large (&gt; 32 × 24 × 20 In)</Option>
                </Select>
              </div>

              <div className={styles['form-group']}>
                <label className={styles['form-label']}>*Fixed Price:</label>
                <Input
                  type='number'
                  className={styles['input']}
                  placeholder="E.G., $100"
                  value={publishDeliveryForm.fixed_price}
                  onChange={(e) => handlePublishDeliveryChange('fixed_price', e.target.value)}
                />
              </div>

              <div className={styles['form-group']}>
                <label className={styles['form-label']}>Notes:</label>
                <Input
                  className={styles['input']}
                  placeholder="Notes"
                  value={publishDeliveryForm.notes}
                  onChange={(e) => handlePublishDeliveryChange('notes', e.target.value)}
                />
              </div>
            </div>

            {/* 右列 */}
            <div className={styles['right-column']}>
              <div className={styles['form-group']}>
                <label className={styles['form-label']}>*Drop-Off Location:</label>
                <div className={styles['nested-inputs']}>
                  <Select
                    className={styles['input']}
                    placeholder="State"
                    value={publishDeliveryForm.destination_point_state}
                    onChange={(v) => handlePublishDeliveryChange('destination_point_state', v)}
                  >
                    {
                      StateList.map((item, index) => (
                        <Option value={item.value} key={index}>{item.label}</Option>
                      ))
                    }
                  </Select>
                  <Input
                    className={styles['input']}
                    placeholder="City"
                    value={publishDeliveryForm.destination_point_city}
                    onChange={(e) => handlePublishDeliveryChange('destination_point_city', e.target.value)}
                  />
                  <Input
                    className={styles['input']}
                    placeholder="Address"
                    value={publishDeliveryForm.destination_point_address}
                    onChange={(e) => handlePublishDeliveryChange('destination_point_address', e.target.value)}
                  />
                </div>
              </div>

              <div className={styles['form-group']}>
                <label className={styles['form-label']}>*Expected Delivery Time:</label>
                <DatePicker
                  showTime
                  format="YYYY-MM-DD HH:mm A"
                  className={styles['input']}
                  value={publishDeliveryForm.expected_delivery_time}
                  placeholder="2025-10-16 2:00 PM"
                  onChange={(v) => handlePublishDeliveryChange('expected_delivery_time', v)}
                />
              </div>

              <div className={styles['form-group']}>
                <label className={styles['form-label']}>*Quantity:</label>
                <Input
                  type="number"
                  className={styles['input']}
                  placeholder="1"
                  value={publishDeliveryForm.quantity}
                  onChange={(e) => handlePublishDeliveryChange('quantity', e.target.value)}
                />
              </div>

              <div className={styles['form-group']}>
                <label className={styles['form-label']}>*Package Weight:</label>
                <Select
                  className={styles['input']}
                  placeholder="Under 2.2 Lbs"
                  value={publishDeliveryForm.package_weight}
                  onChange={(v) => handlePublishDeliveryChange('package_weight', v)}
                >
                  <Option value="Under 2.2 lbs">Under 2.2 lbs</Option>
                  <Option value="2.2-11 lbs">2.2-11 lbs</Option>
                  <Option value="11-22 lbs">11-22 lbs</Option>
                  <Option value="22-44 lbs">22-44 lbs</Option>
                  <Option value="Over 44+ lbs">Over 44+ lbs</Option>
                </Select>
              </div>

              <div className={styles['form-group']}>
                <label className={styles['form-label']}>*Bidding:</label>
                <Input
                  type='number'
                  className={styles['input']}
                  placeholder="E.G., $200"
                  value={publishDeliveryForm.bidding_price}
                  onChange={(e) => handlePublishDeliveryChange('bidding_price', e.target.value)}
                />
              </div>
            </div>
          </div>

          <div className={styles['publish-actions']}>
            <Button className={styles['cancel-btn']} onClick={cancelDeliverySubmit}>Cancel</Button>
            <Button className={styles['post-ride-btn']} type="primary" onClick={submitPostDelivery}>Post Delivery</Button>
          </div>
        </div>
      </Modal>
      {/* 发布送货表单弹窗 */}

      {/* 会员支付成功弹窗 */}
      <Modal
        open={showPaySuccess}
        onCancel={closePaySuccess}
        footer={null}
        width={800}
        centered
        className={styles['pay-success-modal']}
      >
        <div className={styles['pay-success-content']}>
          <div className={styles['success-icon']}>
            <CheckOutlined />
          </div>
          <div className={styles['success-title']}>Pay Success</div>
        </div>
      </Modal>
      {/* 会员支付成功弹窗 */}
      {/* 竞价、一口价弹框 */}
      {(detail && Object.keys(detail).length !== 0) && (
        <OrderDialogCar
          open={dialogOpen}
          mode={dialogMode}
          order={detail}
          onCancel={() => setDialogOpen(false)}
          onConfirm={() => setDialogOpen(false)}
        />
      )}
      {/* 竞价、一口价弹框 */}

    </div>
  );
};

export default CarpoolService; 